import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { PublicGuard } from "./gurds/public.guard";
import { PrivateGuard } from "./gurds/private.guard";
import { DashboardComponent } from "./pages/user/dashboard/dashboard.component";
import { UserComponent } from "./pages/user/user.component";
import { PilotsComponent } from "./pages/user/pilots/pilots.component";

const routes: Routes = [
  { path: "", redirectTo: "user", pathMatch: "full" },
  { path: "login", component: LoginComponent, canActivate: [PublicGuard] },
  {
    path: "user",
    component: UserComponent,
    canActivate: [PrivateGuard],
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [PrivateGuard]
      },
      {
        path: "pilots",
        component: PilotsComponent,
        canActivate: [PrivateGuard]
      }
    ]
  },
  { path: "**", redirectTo: "login", pathMatch: "full" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
